module.exports = __webpack_public_path__ + "img/card_230900730.5397cc91.jpg";